<template>
  <div class="foreword">
    <h1>Foreword</h1>
    <p>
      As part of the BC Centre for Excellence (BC-CfE) in HIV/AIDS's mandate to
      evaluate the outcomes of STOP HIV/AIDS programming in BC, we have developed
      semi-annual HIV/AIDS monitoring reports. These reports provide up-to-date data on
      a variety of key HIV-related surveillance and treatment indicators. Selection of
      these indicators was achieved through a collaborative process with various Health
      Authority (HA) representatives. There are six reports in total, one for each HA
      and one for the province of BC as a whole. In addition, there is a technical report
      which explains how each HIV indicator is calculated. Data used in these reports
      come from the British Columbia Centre for Disease Control (BCCDC), MSP billings,
      hospitalization data from the Discharge Abstract Database, the Sunquest
      Laboratory database at the Provincial Public Health Microbiology and Reference
      Laboratory, Providence Health Care laboratory, BC Vital Statistics, and the BC-CfE
      Drug Treatment Program (DTP) Database.
      The STOP HIV/AIDS program is funded by the Province of British Columbia's Ministry of Health. 
    </p>
    <p>
      The objectives of the semi-annual HIV/AIDS monitoring reports are to:
    </p>
    <ol>
      <li>
        Provide timely HA-specific information on key HIV indicators which will
        guide and inform HIV leaders and innovators in the development of future
        HIV interventions and programs which will ultimately lead to decreasing
        the burden of HIV in BC. The indicators will reflect ongoing or past successful
        public health interventions and highlight areas in the HIV care spectrum
        which require further attention and support.
      </li>
      <li>
        Highlight limitations in our current data due to incomplete or time lagged
        data and to develop future strategies to improve complete and timely data
        capture.
      </li>
    </ol>      
    <p>
      These reports are produced for the benefit of individual HA’s. As such, we are
      enthusiastic about your involvement and cooperation regarding the development
      of these monitoring reports. Please forward your comments and queries to
      Dr. Rolando Barrios, Senior Medical Director
      at the BC-CFE, at <a href="mailto:rbarrios@bccfe.ca">rbarrios@bccfe.ca</a>.
    </p>
    <p><i>
      *Please note that the HIV/AIDS monitoring reports were formerly released on a quarterly basis, 
      but have now transitioned to semi-annual release.
    </i></p>

    <p style="background-color: rgba(255, 255, 0, 0.5);"><i>
      HIV testing, diagnosis and treatment monitoring indicators have been impacted by 
      reductions in the availability of non-essential medical services due to COVID-19 pandemic response measures. 
      Some indicators have recovered near to pre-COVID levels but not to the full extent. Upwards trajectory of other indicators was halted by the pandemic.
    </i></p>
    <p style="background-color: rgba(255, 255, 0, 0.5);">
      The provincial HIV surveillance system, HIV/AIDS Information System (HAISYS), 
      was updated December 2022. Since its launch, we have been working with the BCCDC’s Public Health 
      Reporting Data Warehouse (PHRDW) and PHSA’s Data Analytics, Reporting and Evaluation (DARE) teams 
      to structure the data from HAISYS 2.0 into the STIBBI data mart to make data available 
      for surveillance and reporting. During this time, several enhancements have been made in 
      both HAISYS and STIBBI data systems including:
    </p>    
    <ul style="background-color: rgba(255, 255, 0, 0.5);">
      <li> the incorporation of questions distinguishing clients’ sex from gender identity </li>
      <li>refinement of exposure categories</li>
      <li>refined patient-matching algorithm for HIV cases and testing episodes</li>
    </ul>
    <p style="background-color: rgba(255, 255, 0, 0.5);">
       These planned system changes and data structure enhancements have in minor modifications to certain indicators, including:
    </p>   
    <ul style="background-color: rgba(255, 255, 0, 0.5);"> 
      <li>HIV test episode volumes and rates</li>
      <li>HIV cases broken down by exposure groups</li>
      <li>HIV cases linked to HIV testing (e.g. Stage of Infection)</li>
      <li>gender breakdowns of HIV cases are provided instead of sex breakdowns</li>      
    </ul>  
    <p style="background-color: rgba(255, 255, 0, 0.5);">
       Indicators unaffected by the enhancements include HIV and AIDS case counts.
    </p>

  </div>
</template>

<script>
export default {
  name: 'foreword',
  data () {
    return {
      msg: 'Home'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Foreword.vue?23ae037e